import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/Middle_Ages_-_Islamic_Caliphates.png';

function HistoryPageCaliphates() {
  return (
    <TopicPage
      topicKey="Islamic Caliphates"
      title="History: Islamic Caliphates"
      backgroundImage={bg}
      startRoute="/History-Islamic-Caliphates-Go"
      scrollLabels={[
        "The Rashidun and Umayyads",
        "Abbasid Achievements",
        "Science and Trade",
      ]}
                    backRoute="/history-Middle-Ages"   // go back to the Middle-Ages menu
  backLabel="← Return to topics"
  backButtonClassName="journey-button special"
  backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}

export default HistoryPageCaliphates;   